/**
 * Il sito dei mock: lo stesso del login finto (`mockLoginUser.defaultGroupId`, il Guest).
 *
 * Tutti i record dei mock, del core e dei plugin, stanno qui: un sito solo, scritto una volta.
 * Prima i record del core avevano 1 e il login 20119, e i dati dicevano un sito diverso da
 * quello in cui l'utente lavora (FILO-34).
 */
export const MOCK_GROUP_ID = 20119;
